module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/partners/Rock Entertainment-db004aa2d826453fed2f0f79c716683d.png";